import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { mockData } from '../mock';

const LHRRedirect = () => {
  useEffect(() => {
    // Show loading for 0.5 seconds, then redirect to WhatsApp
    const timer = setTimeout(() => {
      const message = `Hi! I'm interested in Laser Hair Reduction treatment at ${mockData.clinic.name}.`;
      const whatsappUrl = `https://wa.me/${mockData.clinic.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`;
      window.location.href = whatsappUrl;
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-green-50">
      <div className="text-center">
        <div className="mb-8">
          <Loader2 className="w-16 h-16 animate-spin text-green-500 mx-auto" />
        </div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">
          Redirecting to WhatsApp...
        </h2>
        <p className="text-gray-600">
          Please wait while we connect you with our clinic
        </p>
      </div>
    </div>
  );
};

export default LHRRedirect;

